import React, { FC, useEffect, useState } from 'react';
import { Field, reduxForm } from 'redux-form';
import { checkBox, newThemeInput } from '_fields/inputs';
import { phone, lowerCase, words } from '_fields/normalizers';
import { connect } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';
// import { validateUserByEmail } from '../../../api/validateUserByEmail';
import { formValueSelector } from 'redux-form';
import { useForm } from 'react-hook-form';
import { Form } from '@components/shadcn/components/ui/form';
import { RootState } from '@store/reducers';
import { Spinner } from '@components/Spinner/Spinner';
import { Helmet } from 'react-helmet';
import { Button, cn, Stack, Text, useIsInIframe } from 'shared-components';
import {
  ApplyWizardSteps,
  STEP_INTEGRATED_LOGIN,
  STEP_INFO,
  STEP_EQ_LEAD_YOUR_INFORMATION,
  FIELD_VALIDATION,
  STEP_EQ_LEAD_NOT_READY,
} from '@components/ApplyWizard/ApplyWizardSteps';
import { reduxFormZodValidate } from '@utils/reduxFormZodValidate';
import { Auth0LoggedInSetState } from '../../../Auth0LoggedInSetState';
import { useApplyWizardContext } from '../../../context/ApplyWizardContext';
import { change } from 'redux-form';
import { Dispatch } from 'redux';
import withLeadOnSubmit from '@components/Apply/withOnSubmit/withLeadOnSubmit';
import ensureNotLoggedIn from '../../../hooks/ensureNotLoggedIn';
import { z } from 'zod';

type EnhancedInfoProps = {
  dispatch: Dispatch;
  change: any;
  partnerCustomFields: any;
  vendor_url: string;
  ownerEmail: string;
  loanType: string;
  saving: boolean;
  handleSubmit: () => void;
  invalid: boolean;
  user: RootState['user'];
  owner_1_first?: string;
  owner_1_last?: string;
  owner_1_mobile?: string;
  isNotAnOwner?: boolean;
  dealUpdateResponse?: any;
};

const TimeLineStep = ({ step, heading, text }: { step: string; heading: string; text: string }) => (
  <div className="grid grid-cols-1 grid-rows-[30px_min-content_1fr] gap-[10px]">
    <Button
      variant={'steps-current'}
      className="cursor-default border-none rounded-[1000px] !h-[30px] !w-[30px] p-[0px] !max-h-[30px] !max-w-[30px] text-[16px] leading-[110%] font-condensed mx-auto"
    >
      {step}
    </Button>
    {heading && (
      <Text variant="subheadline-sm2" className="!text-[16px] !font-extended !leading-[120%]">
        {heading}
      </Text>
    )}
    {text && (
      <Text variant="body-form-label" className="!text-[16px] !font-standard !leading-[120%]">
        {text}
      </Text>
    )}
  </div>
);

const EQLeadNotReadyInner: FC<EnhancedInfoProps> = ({
  dispatch,
  change,
  handleSubmit,
  invalid,
  saving: savingOnSubmit,
  vendor_url,
  ownerEmail,
  user,
  owner_1_first,
  owner_1_last,
  owner_1_mobile,
  isNotAnOwner,
  dealUpdateResponse,
}) => {
  const auth0 = useAuth0();
  const isOpenedInIframe = useIsInIframe();

  const form = useForm();
  const { changeStepTo, saving } = useApplyWizardContext();
  const privacyLink = `${vendor_url}/privacy-policy`;
  const termsLink = `${vendor_url}/terms`;
  const [error, setError] = useState(false);

  useEffect(() => {
    dispatch(change('application', 'application_type', 'eqlead'));
  }, []);

  if (dealUpdateResponse) {
    return (
      <div className="inline-block">
        {/* <CheckCircle className="mx-auto mb-[20px] mr-[8px] inline text-green-600" size={24} /> */}
        <Text variant="body-form-label" className="text-center">
          We have sent you an SMS to +1 {owner_1_mobile} with a link to continue your application.
        </Text>
      </div>
    );
  }

  return (
    <div className="w-full flex flex-col">
      <Form {...form}>
        <form onSubmit={handleSubmit} className="w-full">
          <div className="relative flex mx-auto">
            <Field
              name={'owner_1_mobile'}
              component={newThemeInput}
              label="Mobile Phone*"
              placeholder={'PHONE NUMBER'}
              formatAsPhone
              data-testid="owner_1_mobile"
              className="!max-w-[402px] !rounded-[100px] !h-[50px] placeholder:!text-charcoal placeholder:!font-condensed placeholder:!italic"
              variant="transparent-black"
              formItemClassName="relative !max-w-[402px] space-y-0 mx-auto"
              extraNode={
                <Button
                  variant="primary-green"
                  color="primary"
                  type="submit"
                  disabled={invalid || saving}
                  // isLoading={saving || validateUserLoading}
                  isLoading={saving || savingOnSubmit}
                  data-testid="info_continue"
                  className="!max-w-[592px] absolute right-[0px] !h-[50px] border-[1px] border-charcoal !py-[12.5px] font-condensed leading-[120%] px-[30px] !text-[16px]"
                >
                  TEXT ME
                </Button>
              }
            />
          </div>
        </form>
      </Form>
    </div>
  );
};

const EQLeadNotReadyWrapper = reduxForm<EnhancedInfoProps, EnhancedInfoProps>({
  form: 'application',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate: reduxFormZodValidate(ApplyWizardSteps[STEP_EQ_LEAD_NOT_READY].zodSchema),
})(EQLeadNotReadyInner);
const appSelector = formValueSelector('application');

const mapStateToProps = (state: RootState) => {
  return {
    partnerCustomFields: state.partnerCustomFields,
    vendor_url: state.brand?.data?.vendor_url,
    ownerEmail: appSelector(state, 'owner_1_email'),
    user: state.user,
    isNotAnOwner: appSelector(state, 'isNotAnOwner'),
    owner_1_first: appSelector(state, 'owner_1_first'),
    owner_1_last: appSelector(state, 'owner_1_last'),
    owner_1_mobile: appSelector(state, 'owner_1_mobile'),
  };
};

export const EQLeadNotReady = withLeadOnSubmit(
  connect(mapStateToProps, (dispatch) => ({
    change,
    dispatch,
  }))(EQLeadNotReadyWrapper),
  STEP_EQ_LEAD_NOT_READY
);
